import React from 'react'
import "./HeaderBottom.scss"
const HeaderBottom = () => {
  return (
    <>
<div class="header_b_parent">
    <marquee>Made in small, limited batches to ensure peak freshness without artificial preservatives—secure yours before it's gone!</marquee>
</div>
    </>
  )
}

export default HeaderBottom